import { createSlice } from '@reduxjs/toolkit'
import {
  addParcelToBagEdit,
  asyncReturnToClient,
  createBag,
  createParcelRegistry,
  fetchAllBags,
  fetchAllSendingRegistry,
  fetchBagById,
  fetchDeliveryTransports,
  fetchParcelById,
  fetchParcelByNumber,
  fetchParcelRegistryById,
  fetchAwaitingParcels,
  fetchAwaitingParcelById,
  updateParcel,
  fetchParcelsByStatus,
  fetchParcelStatuses,
  fetchRegistryByNumber,
  putParcel,
  removeParcelFromBagAsync,
  unpackAwaitingPaymentParcel,
  updateBag,
  fetchShipmentManager,
  // fetchParcels,
  fetchRegistryParcels,
} from './thunk'

const initialState = {
  parcels: [],
  parcelsLoading: false,
  parcelsError: null,

  parcelsRegistry: [],
  parcelsRegistryLoading: false,
  parcelsRegistryError: null,

  parcelData: {},
  parcelDataLoading: false,
  parcelDataError: undefined,

  parcelReturnToClientLoading: false,
  parcelReturnToClientError: undefined,

  unpackAwaitingPaymentLoading: false,
  unpackAwaitingPaymentError: undefined,

  parcelStatusesData: [],
  parcelStatusesLoading: false,
  parcelStatusesError: undefined,

  parcelsByStatus: {},
  parcelsByStatusLoading: false,
  parcelsByStatusError: undefined,

  parcelsInBag: [],
  addParcelToBagEditLoading: false,
  errorAddParcelToBagEdit: undefined,

  parcelDataByNumber: {},
  parcelDataByNumberLoading: false,
  parcelDataByNumberError: undefined,

  createBagLoading: false,
  createBagError: undefined,

  updateBagLoading: false,
  updateBagError: undefined,

  allBags: {},
  allBagsLoading: false,
  allBagsError: undefined,

  bagDataById: {},
  bagDataByIdLoading: false,
  bagDataByIdError: undefined,

  removeParcelFromBagAsyncLoading: false,
  removeParcelFromBagAsyncError: undefined,

  allSendingRegistryData: {},
  allSendingRegistryLoading: false,
  allSendingRegistryError: undefined,

  createParcelRegistryV1Loading: false,
  createParcelRegistryV1Error: undefined,

  parcelRegistryData: {},
  parcelRegistryDataLoading: false,
  parcelRegistryDataError: undefined,

  parcelRegistryDataByNumber: {},
  parcelRegistryDataByNumberLoading: false,
  parcelRegistryDataByNumberError: undefined,

  deliveryTransports: {},
  deliveryTransportsLoading: false,
  deliveryTransportsError: undefined,

  shipmentManagerData: {},
  shipmentManagerLoading: false,
  shipmentManagerError: undefined,

  awaitingParcels: [],
  awaitingParcelsLoading: false,
  awaitingParcelsError: undefined,
  awaitingParcelsTotalElements: 0,

  awaitingParcelById: {},
  awaitingParcelByIdLoading: false,
  awaitingParcelByIdError: undefined,
}

const slice = createSlice({
  name: 'parcels',
  initialState,
  reducers: {
    addParcelToBag: (state, { payload }) => {
      const parcelExit = state.parcelsInBag.find(
        (parcel) => parcel.id === payload.id
      )
      if (parcelExit) {
        return
      }
      state.parcelsInBag = [...state.parcelsInBag, payload]
    },
    removeParcelFromBag: (state, { payload }) => {
      state.parcelsInBag = state.parcelsInBag.filter(
        (parcel) => parcel.id !== payload
      )
    },
    clearBagError: (state) => {
      state.parcelDataByNumberError = undefined
    },
    clearAllParcelsInBag: (state) => {
      state.parcelsInBag = []
    },
    clearBagDataById: (state) => {
      state.bagDataById = {}
    },
    clearAllBagErrors: (state) => {
      state.createBagError = undefined
      state.errorAddParcelToBagEdit = undefined
    },
    clearParcelRegistryData: (state) => {
      state.parcelRegistryData = {}
    },
    clearUpdateBagError: (state) => {
      state.updateBagError = undefined
    },
    clearShipmentManagerData: (state) => {
      state.shipmentManagerData = {}
    },
    clearParcelsRegistry(state) {
      state.parcelsRegistry = []
    },
    clearParcelsByStatus(state) {
      state.parcelsByStatus = {}
    },
    filterByParcelId(state, { payload }) {
      state.parcelsRegistry = state.parcelsRegistry.filter((val) => {
        return Number(payload.parcelId) !== val.id
      })
    },
    cleanAwaitingParcels: (state) => {
      state.awaitingParcels = []
      state.awaitingParcelsLoading = false
      state.awaitingParcelsError = undefined
      state.awaitingParcelsTotalElements = 0
      state.awaitingParcelById = {}
      state.awaitingParcelByIdLoading = false
      state.awaitingParcelByIdError = undefined
    },
  },
  extraReducers: {
    [fetchParcelByNumber.pending]: (state) => {
      state.parcelDataByNumberLoading = true
    },
    [fetchParcelByNumber.fulfilled]: (state, { payload }) => {
      state.parcelDataByNumberLoading = false
      state.parcelDataByNumber = payload || {}
    },
    [fetchParcelByNumber.rejected]: (state, { payload }) => {
      state.parcelDataByNumberLoading = false
      state.parcelDataByNumberError = payload
    },

    [fetchParcelById.pending]: (state) => {
      state.parcelDataLoading = true
    },
    [fetchParcelById.fulfilled]: (state, { payload }) => {
      state.parcelDataLoading = false
      state.parcelData = payload || {}
    },
    [fetchParcelById.rejected]: (state, { error }) => {
      state.parcelDataLoading = false
      state.parcelDataError = error
    },

    [fetchRegistryParcels.pending]: (state) => {
      state.parcelsRegistryLoading = true
    },
    [fetchRegistryParcels.fulfilled]: (state, { payload }) => {
      state.parcelsRegistryLoading = false
      state.parcelsRegistry = payload.data
    },
    [fetchRegistryParcels.rejected]: (state, { error }) => {
      state.parcelsRegistryLoading = false
      state.parcelsRegistryError = error
    },

    // [fetchParcels.pending]: (state) => {
    //   state.parcelsLoading = true;
    // },
    // [fetchParcels.fulfilled]: (state, { payload }) => {
    //   state.parcelsLoading = false;
    //   state.parcels = payload.data;
    // },
    // [fetchParcels.rejected]: (state, { error }) => {
    //   state.parcelsLoading = false;
    //   state.parcelsError = error;
    // },

    [asyncReturnToClient.pending]: (state) => {
      state.parcelReturnToClientLoading = true
    },
    [asyncReturnToClient.fulfilled]: (state) => {
      state.parcelReturnToClientLoading = false
    },
    [asyncReturnToClient.rejected]: (state, { error }) => {
      state.parcelReturnToClientLoading = false
      state.parcelReturnToClientError = error
    },

    [unpackAwaitingPaymentParcel.pending]: (state) => {
      state.unpackAwaitingPaymentLoading = true
    },
    [unpackAwaitingPaymentParcel.fulfilled]: (state) => {
      state.unpackAwaitingPaymentLoading = false
    },
    [unpackAwaitingPaymentParcel.rejected]: (state, { error }) => {
      state.unpackAwaitingPaymentLoading = false
      state.unpackAwaitingPaymentError = error
    },

    [putParcel.pending]: (state) => {
      state.parcelDataLoading = true
    },
    [putParcel.fulfilled]: (state, { payload }) => {
      state.parcelDataLoading = false
      state.parcelData = payload || {}
    },
    [putParcel.rejected]: (state, { error }) => {
      state.parcelDataLoading = false
      state.parcelDataError = error
    },

    [fetchParcelStatuses.pending]: (state) => {
      state.parcelStatusesLoading = true
    },
    [fetchParcelStatuses.fulfilled]: (state, { payload }) => {
      state.parcelStatusesData = payload || {}
    },
    [fetchParcelStatuses.rejected]: (state, { error }) => {
      state.parcelStatusesLoading = false
      state.parcelStatusesError = error
    },

    [fetchParcelsByStatus.pending]: (state) => {
      state.parcelsByStatusLoading = true
    },
    [fetchParcelsByStatus.fulfilled]: (state, { payload }) => {
      state.parcelsByStatusLoading = false
      state.parcelsByStatus = payload || {}
    },
    [fetchParcelsByStatus.rejected]: (state, { payload }) => {
      state.parcelsByStatusLoading = false
      state.parcelsByStatusError = payload
    },

    [fetchAwaitingParcels.pending]: (state) => {
      state.awaitingParcelsLoading = true
    },
    [fetchAwaitingParcels.fulfilled]: (state, { payload }) => {
      state.awaitingParcelsLoading = false
      state.awaitingParcels = payload?.data || []
      state.awaitingParcelsTotalElements = payload?.totalElements || 0
      state.awaitingParcelsError = undefined
    },
    [fetchAwaitingParcels.rejected]: (state, { payload, error }) => {
      state.awaitingParcelsLoading = false
      state.awaitingParcelsError = payload || error
    },
    [fetchAwaitingParcelById.pending]: (state) => {
      state.awaitingParcelByIdLoading = true
      state.awaitingParcelByIdError = undefined
    },
    [fetchAwaitingParcelById.fulfilled]: (state, { payload }) => {
      state.awaitingParcelByIdLoading = false
      state.awaitingParcelById = payload || {}
    },
    [fetchAwaitingParcelById.rejected]: (state, { payload, error }) => {
      state.awaitingParcelByIdLoading = false
      state.awaitingParcelByIdError = payload || error
    },

    [updateParcel.fulfilled]: (state, { payload }) => {
      state.awaitingParcels = state.awaitingParcels.filter(
        (parcel) => parcel.id !== payload?.id
      )
      state.awaitingParcelsTotalElements = Math.max(
        0,
        state.awaitingParcelsTotalElements - 1
      )
    },

    [createBag.pending]: (state) => {
      state.createBagLoading = true
    },
    [createBag.fulfilled]: (state) => {
      state.createBagLoading = false
      state.createBagError = undefined
    },
    [createBag.rejected]: (state, { payload }) => {
      state.createBagLoading = false
      state.createBagError = payload
    },

    [fetchAllBags.pending]: (state) => {
      state.allBagsLoading = true
    },
    [fetchAllBags.fulfilled]: (state, { payload }) => {
      state.allBagsLoading = false
      state.allBags = payload || {}
    },
    [fetchAllBags.rejected]: (state, { payload }) => {
      state.allBagsLoading = false
      state.allBagsError = payload
    },

    [fetchBagById.pending]: (state) => {
      state.bagDataByIdLoading = true
    },
    [fetchBagById.fulfilled]: (state, { payload }) => {
      state.bagDataByIdLoading = false
      state.bagDataById = payload || {}
    },
    [fetchBagById.rejected]: (state, { payload }) => {
      state.bagDataByIdLoading = false
      state.bagDataByIdError = payload
    },

    [updateBag.pending]: (state) => {
      state.updateBagLoading = true
    },
    [updateBag.fulfilled]: (state) => {
      state.updateBagLoading = false
    },
    [updateBag.rejected]: (state, { payload }) => {
      state.updateBagLoading = false
      state.updateBagError = payload
    },

    [addParcelToBagEdit.pending]: (state) => {
      state.addParcelToBagEditLoading = true
    },
    [addParcelToBagEdit.fulfilled]: (state) => {
      state.addParcelToBagEditLoading = false
    },
    [addParcelToBagEdit.rejected]: (state, { payload }) => {
      state.addParcelToBagEditLoading = false
      state.errorAddParcelToBagEdit = payload
    },

    [removeParcelFromBagAsync.pending]: (state) => {
      state.removeParcelFromBagAsyncLoading = true
    },
    [removeParcelFromBagAsync.fulfilled]: (state) => {
      state.removeParcelFromBagAsyncLoading = false
    },
    [removeParcelFromBagAsync.rejected]: (state, { error }) => {
      state.removeParcelFromBagAsyncLoading = false
      state.removeParcelFromBagAsyncError = error
    },
    [fetchAllSendingRegistry.pending]: (state) => {
      state.allSendingRegistryLoading = true
    },
    [fetchAllSendingRegistry.fulfilled]: (state, { payload }) => {
      state.allSendingRegistryLoading = false
      state.allSendingRegistryData = payload || {}
      state.allSendingRegistryError = undefined
    },
    [fetchAllSendingRegistry.rejected]: (state, { error }) => {
      state.allSendingRegistryLoading = false
      state.allSendingRegistryError = error
    },

    [createParcelRegistry.pending]: (state) => {
      state.createParcelRegistryV1Loading = true
    },
    [createParcelRegistry.fulfilled]: (state) => {
      state.createParcelRegistryV1Loading = false
    },
    [createParcelRegistry.rejected]: (state, { payload }) => {
      state.createParcelRegistryV1Loading = false
      state.createParcelRegistryV1Error = payload
    },

    [fetchParcelRegistryById.pending]: (state) => {
      state.parcelRegistryDataLoading = true
    },
    [fetchParcelRegistryById.fulfilled]: (state, { payload }) => {
      state.parcelRegistryDataLoading = false
      state.parcelRegistryData = payload || {}
    },
    [fetchParcelRegistryById.rejected]: (state, { payload }) => {
      state.parcelRegistryDataLoading = false
      state.parcelRegistryDataError = payload
    },
    [fetchRegistryByNumber.pending]: (state) => {
      state.parcelRegistryDataByNumberLoading = true
    },
    [fetchRegistryByNumber.fulfilled]: (state, { payload }) => {
      state.parcelRegistryDataByNumberLoading = false
      state.parcelRegistryDataByNumber = payload || {}
    },
    [fetchRegistryByNumber.rejected]: (state, { payload }) => {
      state.parcelRegistryDataByNumberLoading = false
      state.parcelRegistryDataByNumberError = payload
    },
    [fetchDeliveryTransports.pending]: (state) => {
      state.deliveryTransportsLoading = true
    },
    [fetchDeliveryTransports.fulfilled]: (state, { payload }) => {
      state.deliveryTransportsLoading = false
      state.deliveryTransports = payload || {}
    },
    [fetchDeliveryTransports.rejected]: (state, { payload }) => {
      state.deliveryTransportsLoading = false
      state.deliveryTransportsError = payload
    },
    [fetchShipmentManager.pending]: (state) => {
      state.shipmentManagerLoading = true
    },
    [fetchShipmentManager.fulfilled]: (state, { payload }) => {
      state.shipmentManagerLoading = false
      state.shipmentManagerData = payload || {}
    },
    [fetchShipmentManager.rejected]: (state, { payload }) => {
      state.shipmentManagerLoading = false
      state.shipmentManagerError = payload
    },
  },
})

export const {
  addParcelToBag,
  removeParcelFromBag,
  clearBagError,
  clearAllParcelsInBag,
  clearBagDataById,
  clearAllBagErrors,
  clearParcelRegistryData,
  clearUpdateBagError,
  clearShipmentManagerData,
  filterParcelData,
  clearParcelsRegistry,
  clearParcelsByStatus,
  filterByParcelId,
  cleanAwaitingParcels,
} = slice.actions

export const reducer = slice.reducer
export const selectorParcels = (state) => state[slice.name]

export default slice
